export default {
  isUserLoggedIn: () => (localStorage.getItem('userInfo') /* && isAuthenticated */),
}